import { useState, useEffect } from "react";

export default function usePageLoading(initialDelay = 100): boolean {
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		// Minimal delay ensures skeleton renders
		const timeout = setTimeout(() => setLoading(false), initialDelay);

		return () => clearTimeout(timeout);
	}, []);

	return loading;
}
